import { render, staticRenderFns } from "./MedIngredients.vue?vue&type=template&id=92acdd9a&scoped=true&"
import script from "./MedIngredients.vue?vue&type=script&lang=js&"
export * from "./MedIngredients.vue?vue&type=script&lang=js&"
import style0 from "./MedIngredients.vue?vue&type=style&index=0&id=92acdd9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92acdd9a",
  null
  
)

export default component.exports